import React from 'react';
import { PaginationButton } from './PaginationButton';
import { MaintenanceTask } from '../types';
import { ChevronDownIcon, ChevronUpIcon } from '@/assets/Icons';
import { Icon } from '@/components/shared/display/Icon';

interface PaginationProps {
  onPrevClick: () => void;
  onNextClick: () => void;
  activeTaskPageIndex: number;
  lastTaskPageIndex: number;
  taskPages: Array<Array<MaintenanceTask>>;
}

export const Pagination = ({
  onPrevClick,
  onNextClick,
  taskPages,
  activeTaskPageIndex,
  lastTaskPageIndex,
}: PaginationProps) => {
  return (
    <div className="w-6 h-[3.75rem] flex flex-col justify-stretch">
      <PaginationButton
        className="rounded-tr-lg bg-[#6667DD] hover:bg-[#6667DD] hover:opacity-85 disabled:bg-[#B1B9C3] disabled:cursor-not-allowed disabled:hover:bg-[#B1B9C3]"
        onClick={onPrevClick}
        disabled={activeTaskPageIndex === 0}
      >
        <Icon icon={ChevronUpIcon} className="text-[#FFFFFF]" />
      </PaginationButton>

      <PaginationButton
        className="rounded-br-lg bg-[#6667DD] hover:bg-[#6667DD] hover:opacity-85 disabled:bg-[#B1B9C3] disabled:cursor-not-allowed disabled:hover:bg-[#B1B9C3]"
        onClick={onNextClick}
        disabled={activeTaskPageIndex === lastTaskPageIndex - 1 || !taskPages[activeTaskPageIndex + 1].length}
      >
        <Icon icon={ChevronDownIcon} className="text-[#FFFFFF]" />
      </PaginationButton>
    </div>
  );
};
